import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => (
  <div className="signature-card">
    <Link to={`/product/${product.id}`} className="signature-card-link">
      <div className="signature-image-container">
        <img src={product.image} alt={product.name} className="signature-main-image" />
      </div>
      <div className="signature-caption">
        <div className="caption-top-line">
          <h3>{product.name}</h3>
          <span>{parseFloat(product.price).toFixed(2)}</span>
        </div>
        {product.subtitle && <p className="caption-subtitle">{product.subtitle}</p>}
        
        {/* --- NEW: Add the short description --- */}
        {/* {product.shortDescription && <p className="caption-description">{product.shortDescription}</p>} */}
        
        {/* {product.ingredients && <p className="caption-ingredients">{product.ingredients.join(' / ')}</p>} */}
      </div>
    </Link>
  </div>
);

const ProductCarousel = ({ title, products }) => {
  const carouselRef = useRef(null);
  
  // --- NEW: State to manage button enabled/disabled status ---
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // --- NEW: Function to check scroll position and update button state ---
  const checkScrollPosition = () => {
    const el = carouselRef.current;
    if (el) {
      // Check if we can scroll left
      setCanScrollLeft(el.scrollLeft > 0);
      
      // Check if we can scroll right (with a 1px buffer for precision)
      const isAtEnd = el.scrollWidth - el.scrollLeft - el.clientWidth < 1;
      setCanScrollRight(!isAtEnd);
    }
  };
  
  // A small effect to reset the scroll position if the product list changes
  useEffect(() => {
    const carouselElement = carouselRef.current;
    if (carouselElement) {
      // Initial check on mount
      checkScrollPosition();
      
      // Add event listener for window resize
      window.addEventListener('resize', checkScrollPosition);
      
      // Cleanup function to remove the listener
      return () => {
        window.removeEventListener('resize', checkScrollPosition);
      };
    }
  }, [products]); // Re-run if the products change

  // A small effect to reset the scroll position if the product list changes
  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollTo({ left: 0 });
    }
  }, [products]);

  const handleScroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.clientWidth * 0.8; 
      carouselRef.current.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }
  };


  if (!products || products.length === 0) {
    return null;
  }

  return (
    <section className="product-carousel-section">
      <div className="carousel-header">
        <div className="signature-title-container">
          <h2>{title}</h2>
        </div>
        
        {/* --- NEW: Mobile-only navigation buttons --- */}
        <div className="carousel-navigation">
          <button 
            onClick={() => handleScroll(-1)} 
            disabled={!canScrollLeft}
            aria-label="Scroll left"
          >
            &larr;
          </button>
          <button 
            onClick={() => handleScroll(1)} 
            disabled={!canScrollRight}
            aria-label="Scroll right"
          >
            &rarr;
          </button>
        </div>
      </div>
      <div className="carousel-wrapper">
         <div className="signature-grid" ref={carouselRef}
         onScroll={checkScrollPosition}>
        {products.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      </div>
    </section>
  );
};

export default ProductCarousel;